// Role options and rank mapping for user management. `value` is the backend role
// string (unchanged by #113); `label` is what the UI displays — the lowest role is
// presented as "View Only" since it cannot add/edit/delete tiles or change statuses.
export const ROLE_OPTIONS = [
	{ label: 'SuperAdmin', value: 'SuperAdmin', rank: 1 },
	{ label: 'Admin', value: 'Admin', rank: 2 },
	{ label: 'Owner', value: 'Owner', rank: 3 },
	{ label: 'View Only', value: 'User', rank: 4 }
];

export const getRoleRank = (role) => {
	const found = ROLE_OPTIONS.find(r => r.value === role);
	return found ? found.rank : 99;
};

/** Display label for a backend role string (e.g. 'User' → 'View Only'). */
export const getRoleLabel = (role) => {
	const found = ROLE_OPTIONS.find(r => r.value === role);
	return found ? found.label : role;
};
